import { useState } from 'react';
import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';

import { Button, Text } from '@simplywallst/ui-core';

import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

import type { CurrencyISO } from '@/constants/currencies';

import { currencyToSymbol } from '@/utilities/formatting';

const UpdateAggregatePortfolioCurrencyModal = loadable(
  () => import('@/components/UpdatePortfolioCurrencyModal'),
  {
    resolveComponent: (module) => module.UpdateAggregatePortfolioCurrencyModal,
  }
);

type Props = {
  currencyISO: CurrencyISO;
};

export const AggregatePortfolioChangeCurrency = ({ currencyISO }: Props) => {
  const { trackEvent } = useTracking();
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        styleType="passive"
        aria-label="Change currency"
        alignIcon="right"
        onClick={() => {
          setShowModal(true);
          trackEvent({
            action: 'click',
            modifier: 'aggregatePortfolioChangeCurrency',
          });
        }}
      >
        <Text typography="xSmall" color="inherit">
          {currencyToSymbol[currencyISO]?.currency?.symbol || 'US$'}
        </Text>
        <ChevronDownSmallSolid />
      </Button>

      {showModal && (
        <UpdateAggregatePortfolioCurrencyModal
          currency={currencyISO}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};
